import React from 'react'
import {
  CardsContainer,
  ExternalLink,
  MultiplesV3,
  OfferCard,
} from '@labrav/react-components'
import {
  BuyerDetailRow,
  BuyerInfo,
} from '../../../common/components/DetailRow/DetailRow'

import { useStyles } from './Contacts.styles'

import { DateTime } from 'luxon'
import { standardLabraDateFormat } from '@labrav/common'
import Avatar from '@mui/material/Avatar'
import { useSelector } from '../../../store/hooks'

interface ContactCardProps {
  email: string
  firstName: string
  lastName: string
  title?: string
  createdAt: string
  associatedOffers: string[]
}

const ContactCard: React.FC<ContactCardProps> = ({
  email,
  firstName,
  lastName,
  createdAt,
  associatedOffers,
}) => {
  const { classes } = useStyles()
  const timeZone = useSelector<string>(
    state => state.userProfile.userProfile?.timeZone || 'UTC'
  )
  const offersList =
    associatedOffers?.map((offer: string) => ({
      id: String(offer),
      logoSrc: '',
      copyable: false,
    })) || {}

  return (
    <CardsContainer>
      <OfferCard
        name={
          <div className={classes.name}>
            <Avatar className={classes.avatar}>{firstName?.charAt(0)}</Avatar>
            <div className={classes.text}>
              {`${firstName || ''} ${lastName || ''}`.trim()}
            </div>
          </div>
        }
        isLastCard={true}
        customiseForBuyer={true}
        hideLogo={true}
      />

      <BuyerDetailRow
        children={
          <>
            <BuyerInfo
              title={'Email'}
              value={
                <ExternalLink noreferrer noopener href={`mailto:${email}`}>
                  {email}
                </ExternalLink>
              }
              gridSize={4}
            />
            {associatedOffers && (
              <BuyerInfo
                title={'Associated offers'}
                value={<MultiplesV3 list={offersList} />}
                gridSize={6}
              />
            )}
            {createdAt && (
              <BuyerInfo
                title={'Added on'}
                value={
                  <div>
                    {createdAt
                      ? DateTime.fromISO(createdAt)
                          .setZone(timeZone)
                          .toFormat(standardLabraDateFormat)
                      : '-'}
                  </div>
                }
                gridSize={2}
                showDivider={false}
              />
            )}
          </>
        }
      />
    </CardsContainer>
  )
}

export default ContactCard
